import { render, staticRenderFns } from "./i4pro-data-iterator-table.vue?vue&type=template&id=03c10133&scoped=true"
import script from "./i4pro-data-iterator-table.vue?vue&type=script&lang=js"
export * from "./i4pro-data-iterator-table.vue?vue&type=script&lang=js"
import style0 from "./i4pro-data-iterator-table.vue?vue&type=style&index=0&id=03c10133&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c10133",
  null
  
)

export default component.exports